import React from 'react';
import { motion } from 'framer-motion';

interface GlassCardProps {
  children: React.ReactNode;
  className?: string;
  glowColor?: 'blue' | 'gold' | 'none' | 'pulse';
  disableInteractions?: boolean; // new: remove hover/tap bounce for forms
}

export function GlassCard({
  children,
  className = '',
  glowColor = 'none',
  disableInteractions = false
}: GlassCardProps) {
  const glowClasses = {
    blue: 'shadow-elev-1 hover:shadow-elev-2',
    gold: 'shadow-elev-1 hover:shadow-elev-2',
    none: '',
    pulse: ''
  };
  
  return (
    <motion.div 
      className={`card-glass rounded-2xl backdrop-blur-xl border border-white/10 transition-all duration-300 ease-gentle ${glowColor !== 'pulse' ? glowClasses[glowColor] : ''} ${className}`} 
      {...(!disableInteractions && {
        whileHover: {
          scale: 1.02,
          y: -2,
          transition: {
            type: 'spring',
            stiffness: 400,
            damping: 10
          }
        },
        whileTap: { scale: 0.98 },
      })}
      transition={{ type: 'spring', stiffness: 400, damping: 17 }}
    >
      {glowColor === 'pulse' && (
        <motion.div 
          className="absolute -inset-[1px] rounded-2xl z-[-1]" 
          animate={{
            boxShadow: [
              '0 0 8px 2px rgba(61, 120, 237, 0.3)', 
              '0 0 8px 2px rgba(215, 164, 73, 0.3)', 
              '0 0 8px 2px rgba(61, 120, 237, 0.3)'
            ],
            borderColor: [
              'rgba(61, 120, 237, 0.3)', 
              'rgba(215, 164, 73, 0.3)', 
              'rgba(61, 120, 237, 0.3)'
            ]
          }} 
          transition={{ duration: 3, repeat: Infinity, ease: 'easeInOut' }} 
        />
      )}
      {children}
    </motion.div>
  );
}